import React from 'react'

const Logo = () => (
  // eslint-disable-next-line
  <a href="/" className="logo" />
)

export default Logo
